import React from "react";

const Sobre: React.FC = () => {
  return (
    <section className="section about">
      <div className="container">
        <h2>Sobre MacroInside</h2>
        <p>
          Somos un equipo de ingeniería con obsesión por la calidad, la claridad
          y la entrega continua. Trabajamos cerca del negocio para construir
          software útil y mantenible.
        </p>
      </div>
    </section>
  );
};

export default Sobre;
